import React, { useContext } from 'react';
import BookerShortContext from '../../context/bookerShortContext';
import VehicleInfo from '../RideComponents/VehicleInfo';
import ContactDriver from '../RideComponents/ContactDriver';
import '../../assets/styles/driver-info.sass';

const DriverInfo = () => {
  const { ride } = useContext(BookerShortContext);
  const { vehicle_number } = ride || {};

  if (!vehicle_number) return <></>;
  return (
    <div className="driver-info-wrapper">
      <VehicleInfo />
      <ContactDriver />
    </div>
  );
};

export default DriverInfo;
